import { Component, Input, OnInit } from '@angular/core';
import { NavController, PopoverController } from '@ionic/angular';
import { Subject, from, of, switchMap, take, tap } from 'rxjs';
import { OrderType } from 'src/app/api/contracts/order';
import { InStoreProduct, Product } from 'src/app/api/contracts/product';
import { ClientService } from 'src/app/services/client.service';
import { InStoreProductsService } from 'src/app/services/in-store-products.service';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-in-store-products',
  templateUrl: './in-store-products.component.html',
  styleUrls: ['./in-store-products.component.scss'],
})
export class InStoreProductsComponent implements OnInit {
  public readonly scrollTrigger$ = new Subject<void>();

  @Input() products: InStoreProduct[] | undefined;
  @Input() isOpenedFromModal: boolean = false;

  constructor(
    private readonly navCtrl: NavController,
    private readonly inStoreProductsService: InStoreProductsService,
    private readonly clientService: ClientService,
    private readonly modalService: ModalService
  ) {}

  ngOnInit() {
    if (!this.products) {
      this.clientService.clientLocation$
        .pipe(
          take(1),
          switchMap((location) => {
            if (this.inStoreProductsService.newProducts$.getValue() === null) {
              return this.inStoreProductsService.retrieveInStoreProducts(
                location.hash
              );
            }
            return this.inStoreProductsService.newProducts$;
          }),
          take(1)
        )
        .subscribe((products) => {
          this.products = products || [];
        });
    }
  }

  openProductDetails(product: Product): void {
    from(
      this.isOpenedFromModal ? this.modalService.dismiss() : of(null)
    ).subscribe(() => {
      this.navCtrl.navigateForward(`store/product/${product.id}`, {
        queryParams: {
          type: OrderType.IN_STORE,
        },
      });
    });
  }

  onCloseClick(): void {
    this.modalService.dismiss();
  }

  onSeeAllProductsClick(): void {
    from(
      this.isOpenedFromModal ? this.modalService.dismiss() : of(null)
    ).subscribe(() => {
      this.navCtrl.navigateRoot(`in-store-products`);
    });
  }
}
